/* Sisters Moto rider stories: reading progress, mobile shop bar, photo viewer. */
(function(){
  var root=document.querySelector('.sm-rs');
  if(!root){return;}
  var bar=root.querySelector('.sm-rs__progress span');
  var body=root.querySelector('.sm-rs__body');
  var cta=root.querySelector('.sm-rs__body .cta');
  var sticky=root.querySelector('.sm-rs__sticky');
  var toc=root.querySelector('.sm-rs__body .toc');
  if(toc && window.innerWidth<760){toc.removeAttribute('open');}

  /* mobile shop bar, built from the buttons in the story's shop box */
  if(sticky && cta){
    var links=cta.querySelectorAll('a.btn');
    for(var i=0;i<links.length && i<2;i++){
      var a=document.createElement('a');
      a.href=links[i].getAttribute('href');
      a.textContent=links[i].textContent;
      sticky.appendChild(a);
    }
  }
  if(sticky && !sticky.children.length){sticky.parentNode.removeChild(sticky); sticky=null;}

  var ticking=false;
  function update(){
    ticking=false;
    if(bar && body){
      var r=body.getBoundingClientRect();
      var total=r.height-window.innerHeight;
      var p=total>0?Math.min(1,Math.max(0,-r.top/total)):0;
      bar.style.transform='scaleX('+p+')';
    }
    if(sticky && cta){
      var top=cta.getBoundingClientRect().top;
      sticky.classList.toggle('on', window.scrollY>520 && top>window.innerHeight-40);
    }
  }
  function onScroll(){if(!ticking){ticking=true; window.requestAnimationFrame(update);}}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  update();

  /* photo viewer */
  var dlg=root.querySelector('.sm-rs__lightbox');
  if(dlg && typeof dlg.showModal==='function'){
    var big=dlg.querySelector('img');
    var cap=dlg.querySelector('figcaption');
    var closeBtn=dlg.querySelector('button');
    var open=function(img){
      var fig=img.closest('figure');
      var c=fig?fig.querySelector('figcaption'):null;
      if(!c && fig && fig.parentNode){c=fig.parentNode.querySelector(':scope > figcaption');}
      big.src=img.currentSrc||img.src;
      big.alt=img.alt;
      cap.textContent=c?c.textContent:'';
      dlg.showModal();
    };
    root.querySelectorAll('.sm-rs__body figure img').forEach(function(img){
      img.setAttribute('tabindex','0');
      img.setAttribute('role','button');
      img.setAttribute('aria-label','Enlarge photo: '+(img.alt||''));
      img.addEventListener('click',function(){open(img);});
      img.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault(); open(img);}});
    });
    dlg.addEventListener('click',function(){dlg.close();});
    closeBtn.addEventListener('click',function(e){e.stopPropagation(); dlg.close();});
  }
})();

/* Magazine layout: highlight the section being read in the sidebar contents
   (the last heading that has scrolled past the top third of the screen). */
(function(){
  var links=document.querySelectorAll('.sm-rs__side-toc a[href^="#"]');
  if(!links.length){return;}
  var items=[];
  links.forEach(function(a){
    var el=document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
    if(el){items.push({a:a, el:el});}
  });
  if(!items.length){return;}
  var current=null, ticking=false;
  function update(){
    ticking=false;
    var line=window.innerHeight*0.3, on=null;
    for(var i=0;i<items.length;i++){
      if(items[i].el.getBoundingClientRect().top<=line){on=items[i];}else{break;}
    }
    if(on!==current){
      if(current){current.a.classList.remove('is-on'); current.a.removeAttribute('aria-current');}
      if(on){on.a.classList.add('is-on'); on.a.setAttribute('aria-current','true');}
      current=on;
    }
  }
  window.addEventListener('scroll',function(){if(!ticking){ticking=true; window.requestAnimationFrame(update);}},{passive:true});
  update();
})();
